module.exports = __webpack_public_path__ + "static/img/img_ai_ar_03.a19c790.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_ai_ar_03.jpg
// module id = LIFY
// module chunks = 1